<template>
    <div class="ZoomControl">
        <q-card bordered flat>
            <q-card-section class="q-pa-xs Row">
                <q-btn
                    flat
                    dense
                    textColor="primary"
                    :disabled="!canDecrease || minValue === 0"
                    @click="decreaseValue"
                >
                    <q-icon name="remove" color="primary" />
                    <q-tooltip>
                        {{ $t('visualization.decreaseZoom') }}
                    </q-tooltip>
                </q-btn>
                <q-btn
                    dense
                    flat
                    color="white"
                    textColor="primary"
                    @click="centerChart"
                >
                    <q-icon name="adjust" color="primary" />
                    <q-tooltip>
                        {{ $t('visualization.centerChart') }}
                    </q-tooltip>
                </q-btn>

                <q-btn
                    flat
                    dense
                    textColor="primary"
                    :disabled="!canIncrease"
                    @click="increaseValue"
                >
                    <q-icon name="add" color="primary" />
                    <q-tooltip>
                        {{ $t('visualization.increaseZoom') }}
                    </q-tooltip>
                </q-btn>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'ZoomControl',
    props: {
        value: VueTypes.number.def(100),
        canIncrease: VueTypes.bool.def(false),
        canDecrease: VueTypes.bool.def(false),
    },
    emits: ['increase', 'decrease', 'center-chart'],
    methods: {
        increaseValue() {
            this.$emit('increase')
        },
        decreaseValue() {
            this.$emit('decrease')
        },
        centerChart() {
            this.$emit('center-chart')
        },
    },
}
</script>

<style lang="scss" scoped>
.q-card {
  opacity: 0.4;
  transition: opacity 0.25s;
}
.q-card:hover {
  opacity: 1;
}

.Row {
        display: flex;
        align-items: center;
        gap: 6px;
}

.PercentBadge {
        min-width: 52px;
        justify-content: center;
}
</style>
